import { MockedDragEvent } from 'test/helpers/MockedFile';
import { fileValidation } from './FileValidation';

/**
 * Handles the drop event when files are dropped onto the element.
 * @param {React.DragEvent<HTMLDivElement>} ev - The drag event object.
 * @returns {void}
 */
export const DropHandler = async (
    ev: React.DragEvent<HTMLDivElement> | MockedDragEvent,
    callback: (ev: any) => any,
    updating: (ev: any) => any,
    type = 'drop',
    maxFile = 200
): Promise<any> => {
    ev.preventDefault();
    const { items } = ev.dataTransfer;
    const fileArray: File[] = [];
    for (let i = 0; i < items.length; i += 1) {
        const item = items[i];
        if (item.kind === 'file') {
            const file = item.getAsFile();
            if (file) {
                fileArray.push(file);
            }
        }
    }
    const validation = await fileValidation(
        fileArray,
        (data: any) => {
            callback(data);
        },
        2 * 1024 * 1024 * 1024,
        maxFile,
        type
    )
        .then((res) => res)
        .catch(() => false);
    if (validation) {
        updating(fileArray);
    }
};
